document.addEventListener("turbo:frame-missing", event => {
  if (event.detail.response.redirected) {
    event.preventDefault()
    event.detail.visit(event.detail.response)
  } else if (event.detail.response.status === 500) {
    // Handle
  } else if (event.detail.response.status === 401) {
    // Handle
  }
});
